//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            formData: {},
            follow_up_options: ['email', 'text', 'phone', 'in-person'],
            follow_up: {
                follow_up_method: '',
                follow_up_date: moment().add(30, 'days').format('MM-DD-YYYY'),
                notes: ''
            },
            person: {}
        };
    },
    created: function created() {
        var $el = this;

        Event.$on('add-follow-up', function (item) {
            $el.person = item;
            $el.$children[0].$data.showModal = true;
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('add-follow-up');
    },

    methods: {
        addFollowUp: function addFollowUp() {
            var $el = this;
            var formData = new FormData();
            formData.append("person_id", $el.person.id);
            formData.append("follow_up_method", $el.follow_up.follow_up_method);
            formData.append("notes", $el.follow_up.notes);

            axios.post('/prototype/person/follow-up/create', formData).then(function (response) {
                $el.loading = false;
                $el.active = false;
                $el.$snotify.success('The follow-up was added');
                Event.$emit('close-full-modal');
                Event.$emit('guest-card-dashboard-updated');
                Event.$emit('person-updated');
                $el.follow_up = {};
            });
        },
        close: function close() {
            var $el = this;
            Event.$emit('close-full-modal');
            $el.follow_up.follow_up_method = '';
            $el.follow_up.notes = '';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/AddFollowUp.vue
// module id = XmOV
// module chunks = 0 1